import { render, staticRenderFns } from "./CoIconTemplateContent.vue?vue&type=template&id=2d5c452c&scoped=true&"
import script from "./CoIconTemplateContent.vue?vue&type=script&lang=ts&"
export * from "./CoIconTemplateContent.vue?vue&type=script&lang=ts&"
import style0 from "./CoIconTemplateContent.vue?vue&type=style&index=0&id=2d5c452c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5c452c",
  null
  
)

export default component.exports